export default {
  sections: {
    order_summary: 'Totale ordine',
  },
  labels: {
    add_items: 'Aggiungi articoli per iniziare',
    item_count_one: '{{count}} articolo',
    item_count_other: '{{count}} articoli',
  },
  buttons: {
    return: 'Torna alla revisione ordine',
  },
};
